import { bannerDismissalEndpoints } from './endpoints';

// The closed set of banners a user can dismiss. Not a Partner Preview concept - any banner in
// the hub can be dismissed through the same endpoint, keyed by one of these.
export const BANNER_KEYS = {
	PARTNER_PREVIEW: 'partner_preview',
	LEGACY_OS_VERSION: 'legacy_os_version',
	// The Dashboard invitation to join the Partner Preview Program (SYN-3072). A key of its own so
	// that an earlier dismissal of the SYN-2666 enrolled banner (PARTNER_PREVIEW) does not hide it.
	// rest-api validates this set (BannerKey enum), so a new key must be added there too.
	PARTNER_PREVIEW_INVITATION: 'partner_preview_invitation',
};

export class BannerDismissalService {
	constructor(restAxios) {
		this.restAxios = restAxios;
	}

	// The dismissal belongs to the logged in user, who is resolved from the auth header on the
	// server, so the hub never sends a user id. The response is every dismissal the user has
	// made, across every banner - callers filter by bannerKey. An empty list - a 404 from a
	// deployment that does not expose the endpoint yet - or a payload that is not a list at all
	// (an envelope such as { items: [...] }, the shape the neighbouring enrollments endpoint
	// already uses) all mean "this user has not dismissed anything". Callers iterate the result
	// during render, outside any try/catch, so a non-array here would take their page down.
	getDismissals = (companyId) => {
		return this.restAxios.get(bannerDismissalEndpoints.bannerDismissals, { params: { companyId } })
			.then((response) => {
				return Array.isArray(response.data) ? response.data : [];
			})
			.catch((error) => {
				if (error?.response?.status === 404) {
					return [];
				}

				throw error;
			});
	};

	dismissBanner = (companyId, bannerKey) => {
		return this.restAxios.post(bannerDismissalEndpoints.bannerDismissals, { companyId, bannerKey })
			.then((response) => {
				return response.data;
			});
	};
}
